$.fn.isOnScreen = function(){

    var win = $(window);

    var viewport = {
        top : win.scrollTop(),
        left : win.scrollLeft()
    };
    viewport.right = viewport.left + win.width();
    viewport.bottom = viewport.top + win.height();

    var bounds = this.offset();
    bounds.right = bounds.left + this.outerWidth();
    bounds.bottom = bounds.top + this.outerHeight();

    return (!(viewport.right < bounds.left || viewport.left > bounds.right || viewport.bottom < bounds.top || viewport.top > bounds.bottom));

};


$(document).foundation();


function initMobileMenuControls() {
	var items = $("#menu .l1-item").length;

	$("#menu .l1-item").on("click", function() {
		var itemCount = $(this).find(".sub-menu li").length;

		if (itemCount >= items) {
			$("#menu-wrap .menu-btm").css("transform", "translateY(" + (((itemCount + 1) - items) * 52).toString() + "px)");
		}
	});

	$(document).on("click", "#menu .l1-item .btn-close-sub", function() {
		$("#menu-wrap .menu-btm").css("transform", "none");
	});
}

document.querySelectorAll("a[href]").forEach(element => element.getAttribute("href").startsWith("/") ? null : element.setAttribute("target", "_blank"));

$(function() {

    $('.btn-paypal-donate').on('click', function() {
        $('#paypal-donate-form').submit();
    });
    $('.btn-paypal-international').on('click', function() {
        $('#paypal-international-form').submit();
    });
    $('.btn-paypal-wichita').on('click', function() {
        $('#paypal-wichita-form').submit();
    });
    $('.btn-paypal-dallas').on('click', function() {
        $('#paypal-dallas-form').submit();
    });
    //---------------------------------------------------------
    //  Elements
    //---------------------------------------------------------
    if ($('.rellax').length > 0) {
	requestAnimationFrame(() => {
	        var rellax = new Rellax('.rellax', {
        	    center:true
        	});
	});

        // $('.rellax').each(function(i) {
        //     if ($(this).isOnScreen()) {
        //         var rellax = new Rellax(this, {});
        //     }
        // });

    }

    $("[podcast-progress]").each((_index, element) => {
        const id = element.getAttribute("podcast-progress");

        let audio = document.getElementById(id);

        if (audio instanceof HTMLAudioElement) {
            element.addEventListener("click", event => {
                const { left, width } = element.getBoundingClientRect();

                let time = (event.clientX - left) / width;

                audio.currentTime = time * audio.duration;
            });

            function update() {
                element.style.setProperty("--progress", (audio.currentTime / audio.duration * 100) + "%");

                requestAnimationFrame(update);
            }

            update();
        }
    });

    $("[podcast-play]").on("click", event => {
        const id = event.target.getAttribute("podcast-play");

        let audio = document.getElementById(id);

        if (audio instanceof HTMLAudioElement) {
            if (audio.paused) {
                audio.play();

                event.target.classList.add("playing");
            }
            else {
                audio.pause();

                event.target.classList.remove("playing");
            }
        }
    });

    $(".elements__herocarousel").each((_index, element) => {
        const heading = element.querySelector(".heading");
        const items = parseInt(heading.dataset.items);

        setInterval(() => {
            let next = parseInt(heading.style.getPropertyValue("--index") || "0") + 1;

            heading.style.setProperty("--index", next.toString());

            if (next === items) {
                setTimeout(() => heading.style.setProperty("--index", "0"), 500);
            }
        }, 5500);
    });

    if ($('.content-slider').length > 0) {
        $('.content-slider').slick({
            infinite: true,
            slidesToShow: 1,
            slidesToScroll: 1,
            autoplay:true,
            speed: 600,
            dots: true,
            appendDots: $('.content-slider-wrap'),
            appendArrows: $('.content-slider-wrap'),
            prevArrow:'<a class="slider-prev"><i class="fal fa-chevron-left"></i></a>',
            nextArrow:'<a class="slider-next"><i class="fal fa-chevron-right"></i></a>',
            responsive: [
              {
                breakpoint: 500,
                settings: {
                    arrows: false
                }
              },
            ]
        });
    }

    $(".elements__videocarouselelement").each((_index, element) => {
        $(element).find('.carousel').slick({
            infinite: true,
            nextArrow: $(element).find('.next'),
            prevArrow: $(element).find('.prev'),
            variableWidth: true
        });
    });

    if ($('.image-carousel').length > 0) {
        $('.image-carousel').slick({
            infinite: true,
            slidesToShow: 1,
            slidesToScroll: 1,
            autoplay:true,
            speed: 600,
            dots: false,
            appendArrows: $('.image-carousel-wrap'),
            prevArrow:'<a class="slider-prev"><i class="fal fa-chevron-left"></i></a>',
            nextArrow:'<a class="slider-next"><i class="fal fa-chevron-right"></i></a>',
            responsive: [
              {
                breakpoint: 500,
                settings: {
                    arrows: false
                }
              },
            ]
        });
    }

    if ($('.tile-slider').length > 0) {
        $('.tile-slider').slick({
            infinite: true,
            slidesToShow: $('.tile-slider').data("count"),
            slidesToScroll: 1,
            autoplay:true,
            speed: 600,
            dots: false,
            appendArrows: $('.tile-grid-wrap'),
            prevArrow:'<a class="slider-prev"><i class="fal fa-chevron-left"></i></a>',
            nextArrow:'<a class="slider-next"><i class="fal fa-chevron-right"></i></a>',
            responsive: [
              {
                breakpoint: 500,
                settings: {
                    arrows: false
                }
              },
            ]
        });
    }

    $(".elements__mapelement").each((_index, element) => {
        const reveal = $(element).find(".map-popup");
        const typeTables = {
            "global-office": {
                title: "Global Office",
                color: "#e67e22"
            },
            "regional-office": {
                title: "Regional Office",
                color: "#3498db"
            },
            "emerging-city": {
                title: "Emerging City",
                color: "#2ecc71"
            }
        };

        $(document).on("mousedown", event => {
            reveal.addClass("hidden");
        });

        reveal.on("mousedown", event => event.stopPropagation());

        google.maps.event.addDomListener(window, 'load', () => {
            const center = new google.maps.LatLng(38.084851, -98.878326);
            const mapOptions = {
                zoom: 3,
                scrollwheel: false,
                center: center,
                styles: [
                    {
                        "featureType": "water",
                        "elementType": "geometry",
                        "stylers": [
                            {
                                "color": "#e9e9e9"
                            },
                            {
                                "lightness": 17
                            }
                        ]
                    },
                    {
                        "featureType": "landscape",
                        "elementType": "geometry",
                        "stylers": [
                            {
                                "color": "#f5f5f5"
                            },
                            {
                                "lightness": 20
                            }
                        ]
                    },
                    {
                        "featureType": "road.highway",
                        "elementType": "geometry.fill",
                        "stylers": [
                            {
                                "color": "#ffffff"
                            },
                            {
                                "lightness": 17
                            }
                        ]
                    },
                    {
                        "featureType": "road.highway",
                        "elementType": "geometry.stroke",
                        "stylers": [
                            {
                                "color": "#ffffff"
                            },
                            {
                                "lightness": 29
                            },
                            {
                                "weight": 0.2
                            }
                        ]
                    },
                    {
                        "featureType": "road.arterial",
                        "elementType": "geometry",
                        "stylers": [
                            {
                                "color": "#ffffff"
                            },
                            {
                                "lightness": 18
                            }
                        ]
                    },
                    {
                        "featureType": "road.local",
                        "elementType": "geometry",
                        "stylers": [
                            {
                                "color": "#ffffff"
                            },
                            {
                                "lightness": 16
                            }
                        ]
                    },
                    {
                        "featureType": "poi",
                        "elementType": "geometry",
                        "stylers": [
                            {
                                "color": "#f5f5f5"
                            },
                            {
                                "lightness": 21
                            }
                        ]
                    },
                    {
                        "featureType": "poi.park",
                        "elementType": "geometry",
                        "stylers": [
                            {
                                "color": "#dedede"
                            },
                            {
                                "lightness": 21
                            }
                        ]
                    },
                    {
                        "elementType": "labels.text.stroke",
                        "stylers": [
                            {
                                "visibility": "on"
                            },
                            {
                                "color": "#ffffff"
                            },
                            {
                                "lightness": 16
                            }
                        ]
                    },
                    {
                        "elementType": "labels.text.fill",
                        "stylers": [
                            {
                                "saturation": 36
                            },
                            {
                                "color": "#333333"
                            },
                            {
                                "lightness": 40
                            }
                        ]
                    },
                    {
                        "elementType": "labels.icon",
                        "stylers": [
                            {
                                "visibility": "off"
                            }
                        ]
                    },
                    {
                        "featureType": "transit",
                        "elementType": "geometry",
                        "stylers": [
                            {
                                "color": "#f2f2f2"
                            },
                            {
                                "lightness": 19
                            }
                        ]
                    },
                    {
                        "featureType": "administrative",
                        "elementType": "geometry.fill",
                        "stylers": [
                            {
                                "color": "#fefefe"
                            },
                            {
                                "lightness": 20
                            }
                        ]
                    },
                    {
                        "featureType": "administrative",
                        "elementType": "geometry.stroke",
                        "stylers": [
                            {
                                "color": "#fefefe"
                            },
                            {
                                "lightness": 17
                            },
                            {
                                "weight": 1.2
                            }
                        ]
                    }
                ],
                mapTypeControl: false,
                zoomControl: true,
                zoomControlOptions: {
                    position: google.maps.ControlPosition.LEFT_BOTTOM,
                },
                scaleControl: false,
                streetViewControl: false,
                fullscreenControl: false,
            };

            const map = new google.maps.Map($(element).find(".map")[0], mapOptions);

            fetch("/ajax/mapMarkers")
            .then(res => res.json())
            .then(markers => {
                for (let marker of markers.filter(m => m.content)) {
                    marker.content.TypeName = typeTables[marker.type].title;
                    marker.content.TypeColor = typeTables[marker.type].color;

                    let mapMarker = new google.maps.Marker({
                        position: {
                            lat: marker.lat,
                            lng: marker.lon
                        },
                        map: map,
                        icon: `/_resources/themes/influencers/images/mapmarker_${marker.type}.svg`,
                        animation: google.maps.Animation.DROP
                    });

                    google.maps.event.addListener(mapMarker, "click", event => {
                        // if (marker.url) {
                        //     location.href = marker.url;
                        // }
                        // else {
                        for (let property in marker.content) {
                            if (marker.content[property]) {
                                reveal.find(`[data-content="${property}"]`).text(marker.content[property]).removeClass("hide");
                                reveal.find(`[data-href*="${property}"]`).each((_index, el) => {
                                    el.setAttribute("href", el.dataset.href.replace(property, marker.content[property]));
                                    el.setAttribute("target", "_blank");
                                }).removeClass("hide");
                                reveal.find(`[data-color="${property}"]`).css("--color", marker.content[property]).removeClass("hide");
                            }
                            else {
                                reveal.find(`[data-content="${property}"], [data-href*="${property}"], [data-color="${property}"]`).addClass("hide");
                            }
                        }

                        const { top, left } = element.getBoundingClientRect();
                        const offset = parseInt(reveal.css("width").slice(0, -2)) / 2;
                        const x = "changedTouches" in event.domEvent ? event.domEvent.changedTouches[0].clientX : event.domEvent.clientX;
                        const y = "changedTouches" in event.domEvent ? event.domEvent.changedTouches[0].clientY : event.domEvent.clientY;

                        reveal.css("--x", Math.min(Math.max(x - left, offset), document.body.clientWidth - offset) + "px");
                        reveal.css("--y", (y - top) + "px");

                        requestAnimationFrame(() => reveal.removeClass("hidden"));
                        // }
                    });
                }
            });
        });
    });

    $(".elements__featuredproductselement").each((_index, element) => {
        $(element).find(".products").slick({
            infinite: true,
            autoplay: false,
            arrows: false,
            dots: true,
            responsive: [
                {
                    breakpoint: Infinity,
                    settings: {
                        slidesToShow: 4
                    }
                },
                {
                    breakpoint: 1080,
                    settings: {
                        slidesToShow: 3
                    }
                },
                {
                    breakpoint: 750,
                    settings: {
                        slidesToShow: 2,
                    }
                },
                {
                    breakpoint: 500,
                    settings: {
                        slidesToShow: 1
                    }
                }
            ]
        });
    });

    $(".elements__locationsliderelement").each((_index, element) => {
        $(element).find(".locations").slick({
            infinite: true,
            autoplay: false,
            arrows: true,
            prevArrow: $('#location-prev-arrow'),
            nextArrow: $('#location-next-arrow'),
            dots: true,
            responsive: [
                {
                    breakpoint: Infinity,
                    settings: {
                        slidesToShow: 4
                    }
                },
                {
                    breakpoint: 1080,
                    settings: {
                        slidesToShow: 3
                    }
                },
                {
                    breakpoint: 750,
                    settings: {
                        slidesToShow: 2,
                    }
                },
                {
                    breakpoint: 500,
                    settings: {
                        slidesToShow: 1
                    }
                }
            ]
        });
    });

    //---------------------------------------------------------


    //---------------------------------------------------------
    //  Contact, Prayer & Other Forms
    //---------------------------------------------------------

    $('#contact-form').submit(function() {
        // var submitMessage = $(this).parent().find('.submit-message');
        $('#contact-form').addClass('loading');

        $(this).ajaxSubmit({
            success: function(){
                $('#contact-submit-modal').foundation('open');
                setTimeout(function() {
                    $('#contact-submit-modal').foundation('close');
                },5000);
                // submitMessage.removeClass('hide');
                $('#contact-form').removeClass('loading');
            },
            clearForm:true
        });

        return false;
    });
    $('#newsletter-form').submit(function() {
        var submitMessage = $(this).parent().find('.submit-message');
        $('#newsletter-form').addClass('loading');

        $(this).ajaxSubmit({
            success: function(){
                $('#newsletter-submit-modal').foundation('open');
                setTimeout(function() {
                    $('#newsletter-submit-modal').foundation('close');
                },5000);
                submitMessage.removeClass('hide');
            },
            clearForm:true
        });

        return false;
    });

    $('#prayer-form').submit(function() {
        $('#prayer-form').addClass('loading');
        $(this).ajaxSubmit({
            success: function(){
                $('#prayer-submit-modal').foundation('open');
                setTimeout(function() {
                    $('#prayer-submit-modal').foundation('close');
                },5000);
            },
            clearForm:true
        });

        return false;
    });

    //---------------------------------------------------------


    //---------------------------------------------------------
    //  Header functionality
    //---------------------------------------------------------
    if (Foundation.MediaQuery.current == 'small') {
            var threshold = 100;
    } else {
        var threshold = $('#page-heading').hasClass('height-standard') ? 100 : 200;
    }
    if ($(document).scrollTop() > threshold) {
        $('#header').addClass('solid');
    }

    $(window).scroll(function() {
        $( '.fade-content:in-viewport( 900 )' ).addClass('show-content');

        if (Foundation.MediaQuery.current == 'small') {
            var scrollThreshold = 100;
        } else {
            var scrollThreshold = $('#page-heading').hasClass('height-Standard') ? 100 : 200;
        }

        if ($(document).scrollTop() > scrollThreshold) {
            $('#header').addClass('solid');
        }
        else {
            $('#header').removeClass('solid');
        }
    });
    //---------------------------------------------------------


    //---------------------------------------------------------
    //  Dropdown Navigation Menu
    //---------------------------------------------------------
    $(document).on('click', '.btn-menu', function() {
        $(this).toggleClass('open');
        $('#dropdown-menu').toggleClass('open');
        $('#header').toggleClass('menu-open');
        $('body').toggleClass('menu-open');
        if ($(this).hasClass('open')) {
            $('#nav-shade').fadeIn(300);
        } else {
            $('#nav-shade').fadeOut(300);
        }
        return false;
    });

    $(document).on('click', '.btn-expand', function() {
        $(this).parent().find('.sub-menu').toggleClass('show');
        $(this).toggleClass('expanded');
    });

    $(document).on('click', '#nav-shade', function() {
        $('.btn-menu').removeClass('open');
        $('#dropdown-menu').removeClass('open');
        $('#header').removeClass('menu-open');
        $('body').removeClass('menu-open');
        $('#nav-shade').fadeOut(300);
    });

    $(document).on('click', '.sub-menu-expand', function() {
        $(this).toggleClass('open');
        $(this).parent().find('.sub-menu').toggleClass('open');
    });
    //---------------------------------------------------------


    //---------------------------------------------------------
    //  Flyout menu
    //---------------------------------------------------------
    $(document).on('click', '.btn-mobile-menu', function() {
        $(this).toggleClass('open');
        $('body').toggleClass('menu-open');
        $('#flyout-menu').toggleClass('open');
        return false;
    });

    $(document).on('click', '.link-parent-mobile', function() {
        $('.sub-menu').removeClass('mobile-open');
        $(this).parent().next('.sub-menu').addClass('mobile-open');
        $('#menu').addClass('sub-open');
        return false;
    });

    $(document).on('click', '.btn-close-sub', function() {
        $('.sub-menu').removeClass('mobile-open');
        $('#menu').removeClass('sub-open');
    });

	if (window.innerWidth < 700) initMobileMenuControls();
    //---------------------------------------------------------


    //---------------------------------------------------------
    //  Prayer Wall
    //---------------------------------------------------------
    $(document).on('click', '.btn-pray', function() {
        var self = $(this);
        var prayerRequestID = self.data('prayer-request');
        if (!self.hasClass('liked')) {
            $.ajax({
                url: "/prayer/like/" + prayerRequestID,
                method: 'PUT'
            }).done(function(res) {
		let obj = JSON.parse(res);

                self.addClass('prayed');
                var valueEl = $('#prayer-request-'+prayerRequestID).find('.prayer-count');
                var value = parseInt(valueEl.text());
                $('#prayer-request-'+prayerRequestID).find('.prayer-count').parent().find('.fal').addClass('fas').removeClass('fal');
                valueEl.text(obj[prayerRequestID]);
            });
        }

        return false;
    });


    // Drop Down Navigation
    $('.top-menu-item').mouseenter(function() {
        var navTray = $(this).find('.sub-menu');
        navTray.fadeIn(400);
    }).mouseleave(function(event) {
        var navTray = $(this).find('.sub-menu');
        navTray.fadeOut(250);
    });

    // Autoplay Vimeo when opened in Reveal
    $('[data-reveal]').on('open.zf.trigger', function(){
        var reveal = $(this);
        var embedContent = reveal.find('iframe');
        if (embedContent.length) {
            if (embedContent.attr('src').includes('vimeo')) {
                var player = new Vimeo.Player(embedContent[0]);
                player.play().then(function() {
                    // the video was played
                }).catch(function(error) {
                    switch (error.name) {
                        case 'PasswordError':
                            // the video is password-protected and the viewer needs to enter the
                            // password first
                            break;

                        case 'PrivacyError':
                            // the video is private
                            break;

                        default:
                            // some other error occurred
                            break;
                    }
                });
            }
        }
    });

    $('.blog-date-select').select2();

    $('#blog-search-input').on('change', function() {
        let val = $('#blog-search-input').val();
        $('#blog-search-hidden').val(val)
    });


    $(document).on('click', '#btn-newsletter-cta', function(e) {
        let target = document.getElementById('section-newsletter');
        e.preventDefault();
        target.scrollIntoView({
            behavior: "smooth",
            block: "start",
            inline: "nearest"
        });

    });

    $(document).on('click', '.btn-video-tile', function() {
        let videoID = $(this).data('video');
        let type = $(this).data('type');
        let modal = $('#video-modal');

        if (type == 'Vimeo') {
            var embed = '<iframe id="vimeo-player" width="800" height="500" src="https://player.vimeo.com/video/'+ videoID +'?autoplay=1&api=1&player_id=vimeo-player" frameborder="0" allow="autoplay; fullscreen" webkitAllowFullScreen mozallowfullscreen allowFullScreen></iframe>';
            // populate and open video modal
            modal.find('.video-wrap').html(embed);
        } else {
            var embed = '<iframe id="youtube-player" width="800" height="500" src="https://www.youtube.com/embed/'+ videoID +'?autoplay=1&enablejsapi=1&origin=https://www.influencers.org" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>';
            // populate and open video modal
            modal.find('.video-wrap').html(embed);
        }

        modal.foundation('open');
    });
    $(document).on("closed.zf.reveal", "#video-modal", function() {
        $(this).find('.video-wrap').html("");
    });
    

});

